<style scoped>
.two-part {
  width: 50%;
  padding: 10px;
}
.form-group:not([class*=' col-']) {
  width: 100%;
  width: 33.333333%;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: -5px;
  padding-bottom: -5px;
}
#survey-grid {
  height: 450px;
}
</style>

<template>
    <div>
      <div class="panel-body">
        <h4>Survey</h4>
        <div class="d-flex flex-row-reverse">
            <file-upload
              v-model="files"
              extensions="xlsx"
              accept=".xlsx"
              style="cursor: pointer"
              :multiple="false"
              @input-filter="inputFilter"
              @input-file="inputFile"
            >
            <DxButton
              id="upload-button"
              icon="upload"
              hint="Upload data in spreadsheet file"
              :height="40" 
              :disabled="!editable"/>
            </file-upload >
            <DxButton
              id="refreshButton"
              icon="revert"
              hint="Refresh"
              :height="40"
              @click="refreshGrid" />
            <DxButton
              icon="download"
              hint="Download Survey excel file"
              :height="40"
              @click="downloadContigencyTemplate"
              />
          </div>
      </div>
      <b-alert  v-if="fileUpload !== null" show variant="primary">
      <b-row align-h="between">
        <b-col cols="6">
          <p>
          File {{ fileNameUpload }} is ready to upload. <br/>
          </p>
        </b-col>
        <b-col cols="6"> 
          <b-button class="btn btn-sm" variant="outline-primary" size="sm" @click="submitFile">
            Upload Now
          </b-button>
        </b-col>
      </b-row>
    </b-alert>
    <b-alert v-show="editable && uploadData.jobStatus < 100">
      <p>Your file has been uploaded. It is being processed...</p> 
          <DxProgressBar :value="uploadData.jobStatus" :show-status=true />
    </b-alert>
    <br />
    <DxDataGrid
        id="upload-grid"
        ref="uploadGrid"
          :data-source="uploadsDataSource"
          :show-borders="false"
          :show-column-lines="false"
          :show-row-lines="true"
          column-resize-mode="nextColumn"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :cell-hint-enabled="true"
          :word-wrap-enabled="true"
          :remote-operations="false"
          width="100%"
          :height="300"
          @editing-start="onEditingStart"
        >
        <DxScrolling column-rendering-mode="virtual"/>
        <DxSelection mode="none" />
        <DxEditing
          :allow-updating="false"
          :allow-adding="false"
          :allow-deleting="false && (!dataHasNotBeenUploaded && editable)"
          :use-icons="true"
          mode="row"
        />
        <DxColumn caption="No." :calculate-cell-value="setReportNo"  width="70" >
          <DxFormItem :visible="false"/>
        </DxColumn>
        <DxColumn data-field="startingMD" data-type="number" caption="Starting MD" width="200" />
        <DxColumn data-field="finalMD" data-type="number" caption="Final MD" width="200" />
        <DxColumn data-field="uploadDate" data-type="date" caption="Upload Date" />
        <DxColumn data-field="uploadBy" data-type="text" caption="Uploaded By" />
      </DxDataGrid>
      <br />
      <div class="overflow-auto">
        <p><span >Details on current report </span>
        
          <DxButton
              text="Delete all"
              hint="Delete all survey data in this report"
              styling-mode="text"
              :height="40"
              @click="deleteAll"
              />
        </p>
        <DxDataGrid
          id="survey-grid"
          ref="surveyGrid"
            :data-source="surveyDataSource"
            :show-borders="false"
            :show-column-lines="false"
            :show-row-lines="true"
            column-resize-mode="nextColumn"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :cell-hint-enabled="true"
            :word-wrap-enabled="true"
            :column-auto-width="false"
            @saved="saveRows"
            @selection-changed="onSelectionChanged"
            @row-inserting="onRowInserting"
            @row-removing="onRowRemoving"
            @row-removed="onRowRemoved"
          >
            <DxScrolling mode="virtual" />
            <DxEditing
              :allow-updating="editable"
              :allow-adding="editable"
              :allow-deleting="editable"
              :use-icons="true"
              mode="row"
            />
            <DxColumn
              type="buttons"
              width="120"
            >
              <GridButton name="edit"/>
              <GridButton name="delete"/>
            </DxColumn>
            <DxColumn caption="No." cell-template="rowNoTemplate" width="70" />
            <template #rowNoTemplate="{ data }">
              {{ data.rowIndex + 1 }}
            </template>
            <DxColumn data-field="md" data-type="number" caption="MD" />
            <DxColumn data-field="inc" data-type="number" caption="INC" />
            <DxColumn data-field="azi" data-type="number" caption="AZI" />
            <DxColumn data-field="tvd" data-type="number" caption="TVD" />
            <DxColumn data-field="ns" data-type="number" caption="(+)N/S(-)" />
            <DxColumn data-field="ew" data-type="number" caption="(+)E/W(-)" />
            <DxColumn data-field="vsection" data-type="number" caption="V Section" />
            <DxColumn data-field="dls" data-type="number" caption="DLS" />
            <DxColumn data-field="build" data-type="number" caption="Build" />
            <DxColumn data-field="remarks" data-type="string" caption="Remarks" />
        </DxDataGrid>
      </div>
  </div>
</template>

<script>
import { formMethods, formComputed,authComputed } from '@state/helpers'
import axios from 'axios'
import qs from 'querystring'
import {
  DxDataGrid,
  DxColumn,
  DxScrolling,
  DxEditing,
  DxButtton as GridButton,
  DxSelection,
} from 'devextreme-vue/data-grid'
import notify from "devextreme/ui/notify"
import DxButton from 'devextreme-vue/button'
import mapApiUrl from '@/src/utils/api-mapper'
import CustomStore from 'devextreme/data/custom_store'
import FileUpload from 'vue-upload-component'
import { confirm } from 'devextreme/ui/dialog'

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxEditing,
    DxButton,
    GridButton,
    FileUpload,
    DxSelection,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    submitId: {
        type: Number,
        default: 0,
    },
    editable: {
        type: Boolean,
        default: false,
    },
    wellId: {
        type: Number,
        default: 0,
    },
    reportMap: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      rowSelected: [],
      surveyData: [],
      surveyDataSource: null,
      form: [],
      sourceSubmitId: 0,
      show: true,
      selectedAction: '',
      perPage: 10,
      currentPage: 1,
      maxFileSize: 1024*1024,
      fileNameUpload: '',
      fileUpload: null,
      uploadsDataSource: null,
      dataHasNotBeenUploaded: true,
      uploadClicked: false,
      uploadData: {jobStatus: 0},
      files: [],
      uploadId: 0,
    }
  },
  computed: {
    ...formComputed,
    ...authComputed,
    totalRows() {
      if (this.surveyData) return this.surveyData.length
      else return 0
    },
  },
  watch: {
    wellId() {
      
    },
    submitId: function (value) {
      this.refreshGrid()
    },
  },
  created: function () {
    this.init()
  },
  methods: {
    ...formMethods,
    popUpForm(action) {
      if (action === 'ADD') {
        this.form = []
        this.selectedRow = []
      }
      this.selectedAction = action
    },
    init() {
      this.surveyDataSource = new CustomStore({
        key: 'id',
        load: () => {
          const url = mapApiUrl('/api/form/master/survey/list')
          const params = {submitId: this.submitId}
          return axios.get(url, {params: params}).then(response => response.data)
          /* return fetch(url + `?submitId=${this.submitId}`, {
                    method: 'GET',
                    headers: { 'Authorization': 'Bearer ' + this.currentUser.token,
                               'Content-Type': 'application/json'
                      }})
            // .then(handleErrors)
            .then(response => response.json())
            .catch(() => { throw new Error('Network error') }) */
        },
        onLoaded: (result) => {
            // Result is the array of data received from your backend
            console.log("Store received this data:", result);
            
            // Check if the first item actually contains your key
            if (result && result.length > 0) {
                console.log("Sample item structure:", result[0])
            }
        },
        insert: (values) => {
          values.submitId = this.submitId
          values.dailyReportId = this.submitId
          if (isNaN(values.id)) {
            delete values.id
          }
          const url = mapApiUrl('/api/form/master/survey/add')
          return axios.post(url, qs.stringify(values)).then(response => response) 
        },
        update: (key, values) => {
          values.submitId = this.submitId
          values.id = key
          const url = mapApiUrl('/api/form/master/survey/add')
          return axios.post(url, qs.stringify(values)).then(response => response) 
        },
        remove: (key) => {
        const url = mapApiUrl('/api/form/master/survey/delete')
          return fetch(url + `?id=${key}&submitId=${this.submitId}`, {
                    method: 'DELETE',
                    headers: { 'Authorization': 'Bearer ' + this.currentUser.token,
                               'Content-Type': 'application/json'
                      }})
            // .then(handleErrors)
            .then(response => { 
                if (!response.ok) throw new Error('Network error') })
        },
      })
      this.uploadsDataSource = new CustomStore({
        key: 'submitId',
        load: () => {
          const url = mapApiUrl('/api/form/master/survey/get/forms')
          return axios.get(url, {params: {wellId: this.wellId}})
               .then((response) => {
                 this.uploadData = response.data.data.find(x => x.submitId === this.submitId)
                 this.dataHasNotBeenUploaded = this.uploadData === undefined
                 if (this.dataHasNotBeenUploaded) this.uploadData = {jobStatus: 0}
                 const temp = []
                 for (const data of response.data.data) {
                   const record = {...data}
                   const mapMatch = this.reportMap.find(x => x.submitId === record.submitId)
                   if (mapMatch !== undefined) {
                     record.no = mapMatch.index
                   }
                   temp.push(record)
                 }
                 return {data: temp, totalCount: temp.length}
                 }) 
                .catch(error => new Error(error.message)) 
        },
        onLoaded: (result) => {
            // Result is the array of data received from your backend
            console.log("Store received this data:", result);
            
            // Check if the first item actually contains your key
            if (result && result.length > 0) {
                console.log("Sample item structure:", result[0])
                /* const match = result.find(x => x.submitId === this.submitId)
                if ( match !== undefined) {
                  this.uploadId = match.id
                  this.checkPendingJobs()
                } */
            }
        },
        remove: (key) => {
          
        },
      })
    },
    setReportNo(rowData) {
      const match = this.reportMap.find(x => x.submitId === rowData.submitId)
      return match !== undefined ? match.index : ""
    },
    checkPendingJobs() {
      axios.get(mapApiUrl("/api/form/master/survey/upload/process"), {params: {submitId: this.submitId}})
                      .then(response => {
                        if (response.data === "true") {
                          console.log("Process pending job ok")
                        } else {
                          console.log("Process pending job not ok")
                        }
                      })
      /* if (this.uploadId === 0) return
      const url = mapApiUrl("/api/form/master/survey/upload/monitor")
      axios.get(url, {params: {id: this.uploadId}})
            .then(response => {
              console.log("pending job progress " + response.data)
              if (response.data >= 0 && response.data < 100) {
                axios.get(mapApiUrl("/api/form/master/survey/upload/process"))
                      .then(response => {
                        if (response.data === "true") {
                          console.log("Process pending job ok")
                        } else {
                          console.log("Process pending job not ok")
                        }
                      })
              }
            }) */
    },
    refreshGrid() {
      this.checkPendingJobs()
      this.$refs.uploadGrid.instance.refresh()
      this.$refs.surveyGrid.instance.refresh()
    },
    onRowRemoving(e) {
    },
    onRowRemoved(e) {
    },
    onRowInserting(e) {
      e.data.posNum = this.$refs.surveyGrid.instance.totalCount() + 1
    },
    onEditingStart(e) {
      const currentlyEditable = this.editable && this.submitId === e.data.submitId
      e.cancel = currentlyEditable
    },
    onSelectionChanged(event) {
      this.rowSelected = event.selectedRowsData[0]
    },   
    saveRows(e) {
      notify({ message: 'Survey data has been recorded.', width: 500 }, 'success', 3000)
    }, 
    downloadContigencyTemplate() {
      const url = mapApiUrl('/api/form/master/survey/download')
      axios({
        url: url,
        method: 'GET',
        responseType: 'blob', // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'survey_form_template.xlsx')
        document.body.appendChild(link)
        link.click()
      })
    },
    refreshUploadGrid() {
      this.$refs.uploadGrid.instance.refresh()
    },
    deleteAll() {
      const confirmed = confirm('Are you sure you want to clear all the data for this report? ','Confirmation')
        if (!confirmed) {
          return
        }
      const url = mapApiUrl('/api/form/master/survey/delete-all')
      axios.delete(url, {params: {submitId: this.submitId}})
           .then(response => {
             this.$refs.surveyGrid.instance.refresh()
           })
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }
    },
    inputFile(newFile, oldFile) {
      if (newFile) {
        if (!oldFile) {
          // add
          // console.log('add', newFile.file.name)
        } else {
          // update
          // console.log('update', newFile)
        }
        let fileExceedsLimit = (newFile.size > this.maxFileSize) && (this.maxFileSize > 0)
        if (fileExceedsLimit) {
          // console.log("File size exceeds limit ",newFile.size,this.maxFileSize)
        }
        this.fileNameUpload = newFile.file.name
        this.fileUpload = newFile
      } else if (oldFile) {
        // remove
        // console.log('remove', oldFile)
      }
    },
    submitFile() {
      this.uploadClicked = true
      let formData = new FormData()

      formData.append('submitId', this.submitId)
      formData.append('files', this.files[0].file)
      // console.log(formData)
      const url = mapApiUrl('/api/form/master/survey/upload')
      axios
        .post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          // console.log('response ', response)
          this.fileUpload = null
          this.uploadClicked = false
          this.uploadData = {...response.data.data}
          // this.startPeriodicTask()
          this.refreshUploadGrid()
        })
    },
    uploadClick() {
      this.$refs.fileUploader.load()
    },
    handleFileUpload() {
      this.fileUpload = this.$refs.formfile.files[0]
    },
  },
}
</script>